import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbar, useGridApiRef } from '@mui/x-data-grid';
import {
  TextField, InputAdornment, Box, IconButton, Menu, MenuItem,
  FormControl, Select, CircularProgress, Typography,
  Tooltip
} from '@mui/material';
import AlertIcon from '../assets/alert-icon.svg';
import UpIcon from '../assets/up-icon.svg';
import SemiChart from "react-apexcharts";
import SearchIcon from '../assets/searchico.svg';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EyeMenu from '../assets/eye-menu.svg';
import Trash from '../assets/trahs.svg';
import Deboard from '../assets/deboard.svg';
import DownIcon from '../assets/down-arrow.svg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import defaultLogo from '../assets/companyLogo.jpg';
import PostRequest from '../components/apiConnections/postRequest';
import { useSnackbar } from "notistack";
import Delete from "../assets/delete.svg";
import ModalDialog from "./ModalDialog.js";
import HardDeleteModel from './models/hardDeleteModel.jsx';
import Plus from '../assets/add-details.svg';
import { useSelector } from "react-redux";
import CusotmTagModel from './models/CustomTagModel.jsx';
import { CustomNoRowsOverlay } from './Assessment.js';
import PutRequest from '../components/apiConnections/putRequest.js';
import CustomPagination from '../components/common/customPagination.jsx';

function DataGridLoader() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "200px",
        overflow: "hidden",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
// Donut chart options and series
const donutoptions = {
  chart: {
    height: 100,
    type: "radialBar",
  },
  plotOptions: {
    radialBar: {
      startAngle: -140,
      endAngle: 140,
      hollow: {
        size: "65%",
      },
      track: {
        background: "#332961", // Track background color
        strokeWidth: "100%", // Track thickness
        margin: 0, // Space between bar and track
      },
      dataLabels: {
        name: {
          show: true,
          fontSize: "16px",
        },
        value: {
          show: true,
          fontSize: "16px",
          color: "#fff",
          offsetY: -10, // Center the value vertically
          formatter: function (val) {
            return val + "";
          },
        },
      },
      rounded: false, // Disable rounded corners
    },
  },
  colors: ["#533460"], // Single color for the segment
  stroke: {
    lineCap: "",
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "horizontal",
      shadeIntensity: 0.5,
      gradientToColors: ["#E6171D"],
      inverseColors: false,
      stops: [0, 100],
    },
  },
  labels: [""],
};

// Menu component for the three-dot menu
function RowMenu({ data, handleRemove, handleDeboard, handleView, handleFillDetails, handleEdit }) {

  const [anchorEl, setAnchorEl] = useState(null);
  let selector = useSelector((state) => state.permissionList.permissionList);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const checkPermission = (value) => {
    if (!localStorage.getItem("icu") || localStorage.getItem("icu") === "0") {
      return true;
    }
    else if (selector.includes(value)) return true;
    else return false;
  }

  return (
    <>
      <IconButton onClick={handleClick} className='three-dots-btn'>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className='rowmenu'
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {checkPermission("View Ecosystem Detail") ? <MenuItem onClick={handleView} className='border-bot-line'> <img src={EyeMenu} /> View</MenuItem> : null}

        {!data.isVendorDetailAvailable && localStorage.getItem("roleId") === "1" ?
          <MenuItem onClick={handleFillDetails} className='border-bot-line'><img src={Plus} /> Fill Details</MenuItem>
          : null}

        {data.isVendorDetailAvailable && localStorage.getItem("roleId") === "1" && (data.vendorCurrentStatus === "Onboarding" || data.vendorCurrentStatus === "Due diligence") ?
          <>
            <MenuItem onClick={handleEdit} className='border-bot-line'><img src={Plus} /> Edit Details</MenuItem>
          </>
          :
          null

        }
        {data.vendorCurrentStatus !== "Deboarding" ? <MenuItem onClick={handleDeboard}> <img src={Deboard} /> Deboard</MenuItem> : null}

        {checkPermission("Delete Ecosystem") ? <MenuItem onClick={handleRemove}> <img src={Trash} /> Remove</MenuItem> : null}

      </Menu >
    </>
  );
}


function DatagridVendor({ clientEmail, vendorCount, updatedCount }) {
  const apiRef = useGridApiRef();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false)
  const [vendorList, setVendorList] = useState([]);
  const pageSize = 10;
  const roleId = parseInt(window.localStorage.getItem("roleId"));
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [filterSearch, setFilterSearch] = useState(null)
  const [rowCount, setRowCount] = useState(0);
  const [activeVendorId, setActiveVendorId] = useState(null)
  const [openRemoveModal, setOpenRemoveModal] = useState(false)
  const [opentagModel, setOpen] = useState(false);
  let selector = useSelector((state) => state.permissionList.permissionList);
  const [contentData, setContentData] = useState([]);
  const [scoreUpdated, setScoreUpdated] = useState(false)
  const [removeVendorLoader, setRemoveVendorLoader] = useState(false)
  const [showDeboardLoader, setShowDeboardLoader] = useState(false)
  const [showDeboardModal, setShowDeboardModal] = useState(false)
  const handleClose = () => setOpen(false);

  const location = useLocation();
  var vendors = location.state?.vendors;
  let { id } = useParams();
  let clientId = id;


  const checkPermission = (value) => {
    if (!localStorage.getItem("icu") || localStorage.getItem("icu") === "0") {
      return true;
    }
    else if (selector.includes(value)) return true;
    else return false;
  }


  const columns = [
    {
      field: 'id',
      headerName: '#',
      flex: 0.5,
      // valueGetter: (params) => {

      //   const apiRef = params.api;
      //   console.log(params)
      //   const visibleSortedRows = apiRef.getSortedRows();
      //   const page = apiRef.state.pagination?.paginationModel?.page || 0;
      //   const pageSize = apiRef.state.pagination?.paginationModel?.pageSize || 10;
      //   const rowIndex = visibleSortedRows.findIndex((row) => row.id === params.id);
      //   return page * pageSize + (rowIndex % pageSize) + 1;
      // },
      sortable: false,
      className: 'serial-number',
      disableColumnMenu: true,
    },
    {
      field: 'vendorName',
      headerName: 'Name',
      flex: 1.3,
      // minWidth: 170,  // Ensure minimum width
      disableColumnMenu: true,
      renderCell: (params) => (

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {(params.row.acceptableRisk !== null && Number(params.row.score) && Number(params.row.score) < params.row.acceptableRisk) ? <Tooltip title='Requires Attention' placement="top" followCursor classes={{ tooltip: 'custom-tooltip' }}><img src={AlertIcon} className='alert-absolute-left' alt="icon" /></Tooltip> : null}
          <span className="logo-image-vendor">
            <img className="attack-surface-list-logo" src={`${params.row?.logo}`} alt="Img" onError={(e) => {
              e.target.onerror = null;
              e.target.src = defaultLogo;
            }} />
          </span>
          <span style={{ display: 'flex', gap: '6px' }}>
            {params.value}
          </span>
        </div>
      ),

    },
    // {
    //   field: 'grade', headerName: 'Grade',
    //   flex: 0.5,
    //   minWidth: 70,
    //   disableColumnMenu: true,
    //   renderCell: (params) => {
    //     const score = params.row?.score;
    //     return (<>{(score && Number(score)) ? <img src={
    //       (Number(score) <= 25 ? DScore : Number(score) <= 50 ? CGrade : Number(score) <= 75 ? BGrade : AGrade)
    //     } alt='icon' /> : "-"} </>
    //     )
    //   }
    // },
    {
      field: 'score',
      headerName: 'Risk Score',
      flex: 1,
      // minWidth: 110,  // Ensure minimum width
      disableColumnMenu: true,
      renderCell: (params) => {
        const value = Math.round(params.value);
        const previousScore = Math.round(params.row?.previousScore)
        return (
          <div className="relative radialBar-new">
            {value || value === 0 ? <>
              <SemiChart id="radialBar-new" options={{
                ...donutoptions,
                fill: {
                  ...donutoptions.fill,
                  gradient: {
                    ...donutoptions.fill.gradient,
                    gradientToColors: [value <= 25 ? "#FF0000" : value <= 50 ? "#FFA500" : value <= 75 ? "#FFD700" : "#008000"]
                  }
                }
              }}
                series={[value]}
                type="radialBar"
                height={93}
              />
              {Number(value) !== Number(previousScore) ?
                <span className={`number-up number-up-vendor-list ${Number(value) < Number(previousScore) ? "number-down" : null}`}>
                  {(Number(value) && Number(previousScore)) ? <> <img src={
                    Number(value) < Number(previousScore) ? DownIcon : UpIcon} alt="icon" />
                    {
                      ((Math.abs(Number(params.value) - Number(params.row?.previousScore)) * 100) / Number(params.row?.previousScore))?.toFixed(2)}%</> : null}
                </span> : null}
            </> : "-"}

          </div>
        )
      },
    },
    {
      field: 'relationshipRisk',
      headerName: 'Relationship Risk',
      flex: 1.4,
      // minWidth: 110,
      disableColumnMenu: true,
      renderCell: (params) => {
        let score = params.value;
        let cssClass = "";
        let dynamicLable = "-";
        if ((score || score === 0) && score <= 25) {
          cssClass = "criticaldatagrid";
          dynamicLable = "Critical"
        } else if (score && score <= 50) {
          cssClass = "highdatagrid";
          dynamicLable = "High"
        } else if (score && score <= 75) {
          cssClass = "mediumdatagrid";
          dynamicLable = "Medium"
        } else if (score && score > 75) {
          cssClass = "lowdatagrid";
          dynamicLable = "Low"
        }
        return (
          dynamicLable ? (
            <span className={`tagClass ${cssClass}`}>
              <span className='sqaure-datagrid'>{dynamicLable}</span>
            </span>
          ) : (
            "-"
          )
        );
      }
    },
    // {
    //   field: 'relationshipRisk', headerName: 'Relationship Risk1',
    //   flex: 1, minWidth: 150,
    //   disableColumnMenu: true,
    //   renderCell: (params) => {
    //     let value = params.value;
    //     let riskTag;
    //     if (value && value <= 25) {
    //       riskTag = "Low";
    //     } else if (value && value <= 50) {
    //       riskTag = "Medium";
    //     } else if (value && value <= 75) {
    //       riskTag = "High";
    //     } else if (value && value > 75) {
    //       riskTag = "Critical";
    //     }
    //     return (
    //       riskTag ? (
    //         <span className={`tagClass ${riskTag}`}>
    //           {riskTag}
    //         </span>
    //       ) : (
    //         "-"
    //       )
    //     );
    //   }
    // },
    {
      field: 'industries',
      headerName: 'Industry',
      sortable: false,
      flex: 1,
      // minWidth: 100,
      renderCell: (params) =>
        <Tooltip title={params.value} placement="top" followCursor>
          <div className='industry-text'>{params.value?.length ? params.value[0] : "-"}</div>
        </Tooltip>
    },
    {
      field: 'customTags',
      sortable: false,
      headerName: 'Tags',
      flex: 1.4,
      disableColumnMenu: true,
      // minWidth: 200,  // Ensure minimum width
      renderCell: (params) => {
        const handleOpen = (event) => {
          event.stopPropagation();
          setContentData(params.formattedValue);
          setOpen(true)
        };
        const displayItems = Array.isArray(params.value) ? params.value.slice(0, 2) : [];
        const remainingCount = Array.isArray(params.value) ? params.value.length - 2 : 0;
        return (
          <>
            {displayItems.map((item, index) => (
              <Tooltip key={index} title={item} placement="top" followCursor>
                <span className="cloud-vpn-btn" style={{ marginRight: 4 }}>{item}</span>
              </Tooltip>
            ))}

            {remainingCount > 0 && (
              <span onClick={handleOpen} className="cloud-vpn-btn" style={{ cursor: 'pointer' }}>
                +{remainingCount}
              </span>
            )}
          </>
        );
      },
    },
    {
      field: 'vendorCurrentStatus',
      headerName: 'Status',
      flex: 1,
      sortable: false,
      // minWidth: 125,
      disableColumnMenu: true,
      renderCell: (params) => {
        let status = params.value;
        return (status && (status !== "Due diligence" ?
          <span className={`statusClass ${params.row.jsonId && params.row.isVendorDetailAvailable
            ? status : status === "Deboarding"
              ? "Deboarding" : "Scanning"}`}>

            {status === "Deboarding" ? "Deboarding" : params.row.isVendorDetailAvailable ?
              params.row.jsonId ? status : "Scanning" : "Fill Details"}</span>
          :
          <span className={`statusClass Due_diligence`}>{status}</span>
        ));
      },
    },
    {
      field: 'menu1',
      headerName: '',
      sortable: false,
      flex: 0.5,
      minWidth: 70,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <RowMenu
          data={params.row}
          handleRemove={() => { setOpenRemoveModal(true); setActiveVendorId(params.row?.target); }}
          handleDeboard={() => { setShowDeboardModal(true); setActiveVendorId(params.row?.target) }}
          handleView={() => {
            handleRowClick(params)
            // navigate(`/${roleId === 2 ? "admin" : "dashboard"}/vendorDetails/${params.row.target}`)
          }}

          handleFillDetails={() => navigate(`/dashboard/add-new-vendor/fillDetails`, { state: { domain: params.row.target, vendorStatus: params.row.vendorCurrentStatus, jsonAvailableData: params.row.jsonId ? 1 : 0 } })}
          handleEdit={() => navigate(`/dashboard/edit-vendor-details/${params.row.vendorDetailId}`, { state: { domain: params.row.target, vendorStatus: params.row.vendorCurrentStatus, jsonAvailableData: params.row.jsonId ? 1 : 0 } })}
        />
      }
    },
  ];
  useEffect(() => {
    getVendorDetails(paginationModel.page + 1, paginationModel.pageSize);
  }, [paginationModel, clientEmail, updatedCount, scoreUpdated]);

  useEffect(() => {
    updateVendorsScore()
  }, [])

  useEffect(() => {
    let time = setTimeout(() => {
      if (filterSearch !== null) getVendorDetails(1, paginationModel.pageSize)
    }, 500)
    return () => clearTimeout(time)
  }, [filterSearch])

  const updateVendorsScore = async () => {
    try {
      const endpoint = process.env.REACT_APP_UPDATE_CLIENT_VENDORS_SCORE;
      await PostRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${endpoint}`
      )
        .then((res) => {
          if (res.data?.data?.isUpdated) setScoreUpdated(true)
        })
        .catch((err) => {
          console.log(err, "error while update vendor score")
        });
    } catch (error) {
      console.log(error, "error while update vendor score")
    }
  }

  const getVendorDetails = async (page, limit) => {
    // console.log("getVendorDetails", clientEmail)
    const role = parseInt(window.localStorage.getItem("roleId"));
    if (role === 2 && !clientEmail) return;
    setShowLoader(true);
    setVendorList([])

    const endpoint =
      role === 2
        ? `${process.env.REACT_APP_GET_CLIENT_VENDORS_LIST}/${clientEmail}/${clientId}`
        : process.env.REACT_APP_REQUEST_VENDORS_LIST;

    try {
      const refreshToken = await PostRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_REFRESH_TOKEN}`,
        {},
        {},
        "refreshToken"
      );
      if (refreshToken) {
        const vendor = encodeURIComponent(JSON.stringify(vendors))
        await PostRequest(
          `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${endpoint}?vendors=${vendor}&page=${page}&limit=${limit}&search=${filterSearch || ""}`
        )
          .then((resVendors) => {
            let arrResponse = resVendors.data.data;
            setRowCount(arrResponse?.total || 0);
            if (vendorCount) vendorCount(arrResponse?.total || 0)
            if (Array.isArray(arrResponse?.data)) setVendorList(
              arrResponse?.data?.length
                ? [
                  ...arrResponse?.data?.map((d, i) => ({
                    ...d,
                    id: i + 1 + ((page - 1) * limit),
                    jsonId: d.id,
                    name:
                      d.name
                        ?.substring(0, d.name?.indexOf("."))
                        .charAt(0)
                        .toUpperCase() +
                      d.name
                        ?.substring(0, d.name?.indexOf("."))
                        .substr(1)
                        .toLowerCase(),
                    risk:
                      d.score === "-" ? "-" :
                        d.score <= 25
                          ? "Critical"
                          : d.score <= 50
                            ? "High"
                            : d.score <= 75
                              ? "Medium"
                              : "Low",
                    vendorType: d.vendorType || "-",
                    status: d.status ? "Fulfilled" : "Awaiting"
                  })),
                ]
                : []
            );
            setShowLoader(false);
          })
          .catch((errVendor) => {
            enqueueSnackbar(errVendor.message, { variant: "error" });
            setShowLoader(false);
          });
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      setShowLoader(false);
    }
  };

  const removeData = async (confirmationText) => {
    try {
      console.log(confirmationText, activeVendorId)
      if (confirmationText !== activeVendorId) {
        enqueueSnackbar("please write correct domain", { variant: "error" });
        return;
      }
      setRemoveVendorLoader(true);
      const refreshToken = await PostRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_REFRESH_TOKEN}`,
        {},
        {},
        "refreshToken"
      );
      if (refreshToken) {
        const endpoint = roleId === 2 ? "delete-client-vendor-by-admin" : "unlinked-vendor";
        const payload = {
          vendor: activeVendorId,
          clientEmail: clientEmail,
          confirmationText: confirmationText
        };
        await PostRequest(
          `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${endpoint}`,
          payload
        )
          .then((resVendors) => {
            if (resVendors.data.code === 200) {
              enqueueSnackbar(resVendors.data.message, { variant: "success" });
              setRemoveVendorLoader(false);
              setActiveVendorId(null)
              setTimeout(() => {
                getVendorDetails(paginationModel.page + 1, paginationModel.pageSize)
                setOpenRemoveModal(false)
              }, 500);
            } else {
              setRemoveVendorLoader(false);
              enqueueSnackbar(resVendors.data.message, { variant: "error" });
            }
          })
          .catch((errVendor) => {
            enqueueSnackbar(errVendor.message, { variant: "error" });
            setRemoveVendorLoader(false);
          });
      }
    } catch (err) {
      enqueueSnackbar(err.message || "error while deleting vendor", { variant: "error" });
      setRemoveVendorLoader(false);
    }
  };

  const deboardVendor = async () => {
    setShowDeboardLoader(true);
    const refreshToken = await PostRequest(
      `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_REFRESH_TOKEN}`,
      {},
      {},
      "refreshToken"
    );
    if (refreshToken) {
      const endpoint = process.env.REACT_APP_UPDATE_VENDOR_STATUS;
      const payload = {
        url: activeVendorId,
        status: "Deboarding",
        deboard: true
      };
      await PutRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${endpoint}`,
        payload
      )
        .then((resVendors) => {
          if (resVendors.data.code === 200) {
            enqueueSnackbar(resVendors.data.message, { variant: "success" });
            setShowDeboardLoader(false);
            setShowDeboardModal(false);
            setActiveVendorId(null)
            setTimeout(() => {
              getVendorDetails(paginationModel.page + 1, paginationModel.pageSize)
            }, 100);
          } else {
            setShowDeboardLoader(false);
            enqueueSnackbar(resVendors.data.message, { variant: "error" });
          }
        })
        .catch((errVendor) => {
          enqueueSnackbar(errVendor.message, { variant: "error" });
          setShowDeboardLoader(false);
        });
    }
  };


  const handleSearch = (event) => {
    setFilterSearch(event.target.value)
  };

  const handleRowClick = (params) => {

    if (!checkPermission("View Ecosystem Detail")) return;

    if (!params.row.isVendorDetailAvailable) {
      enqueueSnackbar("Please fill details for this url", { variant: "error" });
    } else if (params.row.jsonId) {
      if (roleId === 2) {
        navigate(`/admin/vendorDetails/${params.row.target}/${clientId}`)
      } else {
        navigate(`/dashboard/vendorDetails/${params.row.target}`)
      }
    }
    else {
      enqueueSnackbar("No Record available for this url", { variant: "error" });
    }

  };
  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };
  const onFilterChange = (value) => {
    let searchQuery = value.quickFilterValues[0] || ""
    setFilterSearch(searchQuery)
  }
  const removeModalContent = () => {
    return (
      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        <img src={Delete} alt="icon" />
        <h3 className="send-assessments" style={{ whiteSpace: "nowrap" }}>
          Are you sure you want to Deboard this vendor ?
        </h3>
      </Typography>
    );
  };
  return (
    <>
      {roleId !== 2 ? <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', top: '-9px', left: '13px' }}>
        <FormControl className='select-entries' variant="outlined" size="small">
          <Select
            value={paginationModel.pageSize}
            onChange={(e) => handlePaginationModelChange({ page: 0, pageSize: e.target.value })}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
          </Select>
        </FormControl>
        <span className='entries-per'>entries per page</span>
      </div> : null}
      <Box
        sx={{
          width: '100%',
          '& .MuiDataGrid-columnHeaders': {
            minWidth: '100%',
            overflowX: 'hidden',
          },
          '& .MuiDataGrid-virtualScroller': {
            minWidth: '100%',
            overflowX: 'auto',
          },

        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search…"
          value={filterSearch}
          onChange={handleSearch}
          className='searh-text-field topsearch-top-0'
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img src={SearchIcon} alt='icon' />
              </InputAdornment>
            ),
          }}
        />
        <DataGrid
          apiRef={apiRef}
          rows={vendorList} // Ensure you're using the filtered rows
          columns={columns}
          pageSize={pageSize}
          rowHeight={70}
          paginationMode="server"
          pageSizeOptions={[5, 10, 25]}
          onPaginationModelChange={handlePaginationModelChange}
          paginationModel={paginationModel}
          rowCount={rowCount}
          slots={{
            toolbar: GridToolbar,
            noRowsOverlay: CustomNoRowsOverlay,
            loadingOverlay: DataGridLoader,
            pagination: CustomPagination,
          }}
          slotProps={{
            pagination: {
              paginationModel,
              onPaginationModelChange: handlePaginationModelChange,
              rowCount
            },
          }}
          loading={showLoader}
          filterMode="server"
          onFilterModelChange={onFilterChange}
          disableSelectionOnClick
          disableRowSelectionOnClick
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          disableColumnMenu
          autoHeight
          className='datagrid-table click-hover-datagrid'
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              minWidth: '100%', // Column headers take up full width
            },
            '& .MuiDataGrid-virtualScroller': {
              minWidth: '100%', // Rows take up full width
            },            
          }}
          onRowClick={handleRowClick}          
        />
      </Box>

      <ModalDialog
        handleClose={() => { setShowDeboardModal(false); setActiveVendorId(null) }}
        open={showDeboardModal}
        loader={showDeboardLoader}
        onSubmit={deboardVendor}
        contentData={removeModalContent()}
      />
      <HardDeleteModel
        handleClose={() => { setOpenRemoveModal(false); setActiveVendorId(null) }}
        open={openRemoveModal}
        onSubmit={removeData}
        loader={removeVendorLoader}
        activeVendor={activeVendorId}
        text={"This action will permanently delete all associated assessments, remediations, and documents related to the ecosystem."}
        type="vendor"
      />
      <CusotmTagModel
        open={opentagModel}
        handleClose={handleClose}
        contentData={contentData}
      />
    </>
  );
}

export default DatagridVendor;
